import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { StringValidationRule, NumberValidationRule } from '../../../../data/validation/rules'

const getDefaultState = () => {
    return {
        updatingFlightOffer: false,
        loadingFlightOffer: false,
        airlineName: "",
        airlineLogo: "",
        departureCode: "",
        departureCity: "",
        arrivalCode: "",
        arrivalCity: "",
        tripType: 0,
        price: 0,
        currency: "NGN",
        badge: 0,
        status: 0,
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const loadFlightOffer = instance => {
    instance.setState({ ...instance.state, loadingFlightOffer: true })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/flight",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            id: instance.props.match.params.id
        }
    }).then(response => handleLoadFlightOfferResponse(instance, response))
    .catch(error => alert(error))
}

const handleLoadFlightOfferResponse = (instance, response) => {

    if (response.data.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            const flightOffer = response.data.data.flightOffer
            instance.setState({
                ...instance.state,
                loadingFlightOffer: false,
                airlineName: flightOffer.airlineName,
                airlineLogo: flightOffer.airlineLogo,
                departureCode: flightOffer.departureCode,
                departureCity: flightOffer.departureCity,
                arrivalCode: flightOffer.arrivalCode,
                arrivalCity: flightOffer.arrivalCity,
                tripType: flightOffer.tripType,
                price: flightOffer.price,
                currency: flightOffer.currency,
                badge: flightOffer.badge,
                status: flightOffer.status,
                flag: {
                    type: "",
                    text: ""
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                loadingFlightOffer: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors

    validation.addValidationRule(StringValidationRule, instance.state.airlineName, (error) => errors.airlineName = error, { min: { value: 2, error: "Too short" }, max: { value: 150, error: "Too long" } })
    if (!instance.state.airlineLogo) {
        errors.airlineLogo = "Required"
    }
    else {
        errors.airlineLogo = ""
    }
    validation.addValidationRule(StringValidationRule, instance.state.departureCode, (error) => errors.departureCode = error, { min: { value: 3, error: "Must be 3 letters" }, max: { value: 3, error: "Must be 3 letters" } })
    validation.addValidationRule(StringValidationRule, instance.state.departureCity, (error) => errors.departureCity = error, { min: { value: 2, error: "Too short" }, max: { value: 100, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.arrivalCode, (error) => errors.arrivalCode = error, { min: { value: 3, error: "Must be 3 letters" }, max: { value: 3, error: "Must be 3 letters" } })
    validation.addValidationRule(StringValidationRule, instance.state.arrivalCity, (error) => errors.arrivalCity = error, { min: { value: 2, error: "Too short" }, max: { value: 100, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.currency, (error) => errors.currency = error, { min: { value: 3, error: "Must be 3 letters" }, max: { value: 3, error: "Must be 3 letters" } })

    validation.addValidationRule(NumberValidationRule, instance.state.tripType, (error) => errors.tripType = error, { min: { value: 0, error: "Too low" }, max: { value: 1, error: "Too high" } })
    validation.addValidationRule(NumberValidationRule, instance.state.price, (error) => errors.price = error, { min: { value: 0, error: "Too low" }, max: { value: 100000000, error: "Too high" } })
    validation.addValidationRule(NumberValidationRule, instance.state.badge, (error) => errors.badge = error, { min: { value: 0, error: "Too low" }, max: { value: 3, error: "Too high" } })
    validation.addValidationRule(NumberValidationRule, instance.state.status, (error) => errors.status = error, { min: { value: 0, error: "Too low" }, max: { value: 2, error: "Too high" } })

    let validate = validation.validate() && errors.airlineLogo.length === 0
    instance.setState({
        ...instance.state,
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    })
    return validate
}

const updateFlightOffer = (instance) => {
    instance.setState({ ...instance.state, updatingFlightOffer: true })
    const formData = new FormData()
    formData.append("id", instance.props.match.params.id)
    formData.append("airlineName", instance.state.airlineName)
    formData.append("departureCode", String(instance.state.departureCode).toUpperCase())
    formData.append("departureCity", instance.state.departureCity)
    formData.append("arrivalCode", String(instance.state.arrivalCode).toUpperCase())
    formData.append("arrivalCity", instance.state.arrivalCity)
    formData.append("tripType", instance.state.tripType)
    formData.append("price", instance.state.price)
    formData.append("currency", String(instance.state.currency).toUpperCase())
    formData.append("badge", instance.state.badge)
    formData.append("status", instance.state.status)
    if (instance.state.airlineLogo instanceof File) {
        formData.append("airlineLogo", instance.state.airlineLogo)
    }
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/flight/update",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: formData
    }).then(response => handleUpdateFlightOfferResponse(instance, response.data))
    .catch(error => alert(error))
}

const handleUpdateFlightOfferResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                updatingFlightOffer: false,
                flag: {
                    type: "success",
                    text: "Flight Offer Updated"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                updatingFlightOffer: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const EditFlightOfferWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        loadFlightOffer: () => loadFlightOffer(instance),
        updateFlightOffer: () => updateFlightOffer(instance)
    }
}

export default EditFlightOfferWorker
